import type { CostRow } from '../model/types'

/**
 * Стоимость продукта в изделии: цена упаковки, делённая на её объём и
 * умноженная на расход. Возвращает null, если строка ещё не заполнена — такая
 * строка остаётся в таблице, но в сумму не идёт.
 */
export const rowCost = (row: CostRow): number | null => {
  const { packAmount, packPrice, usedAmount } = row
  if (packAmount == null || packPrice == null || usedAmount == null) return null
  // Пустая упаковка означала бы деление на ноль.
  if (packAmount <= 0) return null
  if (packPrice < 0 || usedAmount < 0) return null
  return (packPrice / packAmount) * usedAmount
}

/** Себестоимость изделия — сумма заполненных строк. */
export const totalCost = (rows: readonly CostRow[]): number =>
  rows.reduce((sum, row) => sum + (rowCost(row) ?? 0), 0)

/** Сколько строк уже участвует в расчёте — чтобы показать это пользователю. */
export const countedRows = (rows: readonly CostRow[]): number =>
  rows.filter(row => rowCost(row) != null).length

/** Рубли с округлением до копеек и без «-0». */
export const formatRub = (value: number): string => {
  const rounded = Math.round(value * 100) / 100
  const safe = Object.is(rounded, -0) ? 0 : rounded
  return `${safe.toLocaleString('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })} ₽`
}
